import React from "react";
import AreaSectionTitle from "./AreaSectionTitle";
import AreaHeader from "./AreaHeader";
import PageMetaHelmet from "../PageMetaHelmet/PageMetaHelmet";

const Area = ({ helmet, title, information, sideButtons, customSideButtons, leftButton, areHeader, children, navigatedId, navigation }) => {
    return (
        <div className='area-component'>
            <PageMetaHelmet title={helmet} icon={"/icons/favicon.ico"} />
            <AreaSectionTitle
                leftButton={leftButton}
                title={title}
                information={information}
                sideButtons={sideButtons}
                customSideButtons={customSideButtons}
                navigatedId={navigatedId}
                navigation={navigation}
            />
            {
                areHeader ?
                    <AreaHeader />
                    :
                    null
            }
            <div className="area-body">
                {children}
            </div>
        </div>
    );
};

export default Area;
